module.exports = __webpack_public_path__ + "static/2018-quadratisch-40af35d9f9e94c92cb4272b8782278a3.jpg";